import { render, staticRenderFns } from "./userChgCard.vue?vue&type=template&id=4001a856&scoped=true&"
import script from "./userChgCard.vue?vue&type=script&lang=js&"
export * from "./userChgCard.vue?vue&type=script&lang=js&"
import style0 from "./userChgCard.vue?vue&type=style&index=0&id=4001a856&lang=less&scoped=true&"
import style1 from "./userChgCard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4001a856",
  null
  
)

export default component.exports